export default {"src":"/_next/static/media/mfi-logo-dark.6e1cb387.svg","height":415,"width":544,"blurWidth":0,"blurHeight":0};